// extracted by mini-css-extract-plugin
export default {"product-card-descriptions":"ProductCard_product-card-descriptions__-bT13","card-image":"ProductCard_card-image__GjMuc","card-section":"ProductCard_card-section__i4L+a"};